<template>
  <div class="tw-absolute tw-w-full">
    <div
      class="tw-absolute tw-h-10 tw-brightness-150"
      :class="[
        small
          ? 'tw--mt-0 tw-w-[calc(100%-1.75rem)] tw-ml-3.5'
          : 'tw--mt-3.5 tw-w-[calc(100%-1.25rem)] tw-ml-2.5',
        isFrontend
          ? `mod-global--border-radius tw-bg-dark-1 tw-border-t ${isLight ? 'tw-border-black/50' : 'tw-border-black'}`
          : 'game-tile-radius game-tile-background-color tw-brightness-50',
      ]"
    />
    <div
      class="tw-absolute tw-brightness-[1.75] tw-h-10"
      :class="[
        small
          ? 'tw-mt-1 tw-w-[calc(100%-0.75rem)] tw-ml-1.5'
          : 'tw--mt-2 tw-w-[calc(100%-0.5rem)] tw-ml-1 ',
        isFrontend
          ? `mod-global--border-radius tw-bg-dark-2 tw-border-t ${isLight ? 'tw-border-black/60' : 'tw-border-black'}`
          : 'game-tile-radius game-tile-background-color tw-brightness-75',
      ]"
    />
  </div>
</template>
<script>
import { useTheming } from '@composables'
import { isFrontend } from '@config'

export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { isLight } = useTheming()

    return {
      isFrontend,
      isLight,
    }
  },
}
</script>
